export const environment = {
  production: true,
  enableIpInfo: true,
  pathapi: 'https://app-backend.foreignadmits.com/api',
  path: 'https://app-backend.foreignadmits.com/',
  shortlistingUrl: 'https://uat.mydreamuniversity.in/api'
};
